import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import {
  getNodeReferenceableVariablesCreate,
  resolveReferenceableVariablesCreate,
  type ResolveReferenceableVariables,
} from "../nodes/index.ts";
import { resolveActiveNodesSelector } from "../nodes/querySelectors/index.ts";
import { getManifestSelector, getParentContextByIdSelector } from "../state/index.ts";

const resolveReferenceVariablesSelector = createSelector(
  [getManifestSelector, getParentContextByIdSelector, resolveActiveNodesSelector],
  (getManifest, getParentContextById, resolveActiveNodes) =>
    resolveReferenceableVariablesCreate(
      resolveActiveNodes,
      getNodeReferenceableVariablesCreate(getManifest, getParentContextById),
    ),
);

export const useResolveReferenceVariables = (): ResolveReferenceableVariables =>
  useSelector(resolveReferenceVariablesSelector);
